import airbrake from 'src/initializers/Airbrake'
import * as ErrorCodes from 'src/ErrorCodes'
import * as ErrorReasons from 'src/ErrorReasons'

// inspired by Parse-SDK-JS
// http://docs.parseplatform.org/js/guide/#error-handling
// http://docs.parseplatform.org/js/guide/#error-codes

// extending errors :
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error
// https://stackoverflow.com/questions/1382107/whats-a-good-way-to-extend-error-in-javascript

export function InternalError (message) {
  this.name = 'InternalError'
  this.message = message
  this.stack = (new Error()).stack
}
InternalError.prototype = Object.create(Error.prototype)
InternalError.prototype.constructor = InternalError

export function PublicError (code, message, options = {}) {
  this.name = 'PublicError'
  this.code = code
  this.message = message
  this.stack = (new Error()).stack

  if (code === ErrorCodes.INVALID_PARAMETER) {
    // TODO: use types to remove this (verify at build step)
    if (!options.parameter || !options.reason) {
      airbrake.notify(new InternalError('missing _parameter_ or _reason_ in PublicError'))
    }
    this.invalidParameter = options.parameter
    this.invalidReason = options.reason
  }
}
PublicError.prototype = Object.create(Error.prototype)
PublicError.prototype.constructor = PublicError

PublicError.Codes = ErrorCodes
PublicError.Reasons = ErrorReasons

export function UnhandledErrorWithoutStatus (error) {
  this.name = 'UnhandledErrorWithoutStatus'
  this.message = error.message
  this.stack = error.stack
}
UnhandledErrorWithoutStatus.prototype = Object.create(Error.prototype)
UnhandledErrorWithoutStatus.prototype.constructor = UnhandledErrorWithoutStatus

export function UnhandledErrorInQueue (error) {
  this.name = 'UnhandledErrorInQueue'
  this.message = error.message
  this.stack = error.stack
}
UnhandledErrorInQueue.prototype = Object.create(Error.prototype)
UnhandledErrorInQueue.prototype.constructor = UnhandledErrorInQueue

export function NotWrappedError (error) {
  this.name = 'NotWrappedError'
  this.message = error.message
  this.stack = error.stack
}
NotWrappedError.prototype = Object.create(Error.prototype)
NotWrappedError.prototype.constructor = NotWrappedError



// WEBPACK FOOTER //
// ./src/Error.js